import { connect } from 'react-redux'
import React, { PureComponent } from 'react'
import TeacherWinners, { ISkin } from '../../views/teacherWinners/TeacherWinners'
import viewSelector from '../../redux/selectors/teacherWinners/viewSelector'
import withTransition from '../../hoc/Transition'
import withRendererFilter from '../../hoc/RendererFilter'
import { IMountainPlayerData } from '../../helpers/data/mountainPlayer'
import viewTypes from '../../helpers/enums/views'
import { IStore } from '../../redux/reducers/index'

interface IGameProps {
	players: IMountainPlayerData[]
	skin: ISkin
	totalActivities: number
}

class TeacherGameConnector extends PureComponent<IGameProps> {
	render() {
		return (
			<TeacherWinners
				players={this.props.players}
				skin={this.props.skin}
				totalActivities={this.props.totalActivities}
			/>
		)
	}
}

const mapStateToProps = (state: IStore) => {
	return viewSelector(state)
}

export default withTransition(
	connect(mapStateToProps, null)(withRendererFilter(TeacherGameConnector, viewTypes.TEACHER_WINNERS))
)
